import { createContext, useContext, useEffect, useState, createElement } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const AccessCtx = createContext(null);

export function AccessProvider({ children }) {
  const { accountId, account } = useAuth();
  const [state, setState] = useState({ areas: null, nav: null });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const f = () => setTick((t) => t + 1);
    window.addEventListener("bos-nav-refresh", f);
    return () => window.removeEventListener("bos-nav-refresh", f);
  }, []);
  const key = [...(account?.enabled_modules || []), ...(account?.released_nav || [])].join(",");
  useEffect(() => {
    if (!accountId) return;
    Promise.all([api.get("/my-access").then((r) => r.data.areas).catch(() => ({})), api.get("/my-nav").then((r) => r.data).catch(() => ({ lab: false, manager: false, items: [] }))])
      .then(([areas, nav]) => setState({ areas, nav }));
  }, [accountId, key, tick]);
  return createElement(AccessCtx.Provider, { value: state }, children);
}

export function useAccess() {
  const { areas, nav } = useContext(AccessCtx) || {};
  return { ready: areas != null && nav != null, nav, can: (area, action = "view") => !area || !!areas?.[area]?.includes(action) };
}
